export const CountryIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 8.33203C9.1046 8.33203 10 7.43663 10 6.33203C10 5.22746 9.1046 4.33203 8 4.33203C6.8954 4.33203 6 5.22746 6 6.33203C6 7.43663 6.8954 8.33203 8 8.33203Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.99935 14.6654C9.33268 11.9987 13.3327 10.2776 13.3327 6.66536C13.3327 3.71984 10.9449 1.33203 7.99935 1.33203C5.05383 1.33203 2.66602 3.71984 2.66602 6.66536C2.66602 10.2776 6.66602 11.9987 7.99935 14.6654Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
